import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-question-modal',
    templateUrl: './question-modal.component.html',
    styleUrls: ['./question-modal.component.scss'],
    standalone: false
})
export class QuestionModalComponent implements OnInit {
  header: string = this.translate.instant('general.logout-header');
  text: string = this.translate.instant('general.logout-text');
  showWarningIcon = true;

  constructor(
    private translate: TranslateService,
    public dialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
  ) {
    if (this.dynamicDialogConfig?.data) {
      this.header = this.dynamicDialogConfig.data.header;
      this.text = this.dynamicDialogConfig.data.text;
      this.showWarningIcon = this.dynamicDialogConfig.data.showWarningIcon;
    }
  }

  ngOnInit(): void {}

  ok() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }

  close() {
    this.dialogRef.close(false);
  }
}
